import { DoctorStep } from 'src/app/components/Pages/GetStarted/OnboardingSteps/DoctorStep/DoctorStep';
import { WelcomeBack } from 'src/app/components/Pages/GetStarted/OnboardingSteps/WelcomeBack/index';
import { JoinWaitList } from 'src/app/components/Pages/GetStarted/Waitlist/JoinWaitlist';
import { WaitlistConfirmation } from 'src/app/components/Pages/GetStarted/Waitlist/WaitlistConfirmation';
import { setNextOnboardingStep, setPreviousOnboardingStep } from 'src/app/state/actions';
import { useDispatch } from 'src/app/state/store';

import { CaptchaStep } from '../OnboardingSteps/CaptchaStep/CaptchaStep';
import { ContactStep } from '../OnboardingSteps/ContactStep/ContactStep';
import { EligibilityConfirmation } from '../OnboardingSteps/EligibilityConfirmation';
import { IneligibleStep } from '../OnboardingSteps/IneligibleStep';
import { DoctorIntentStep } from '../OnboardingSteps/IntentStep/DoctorIntentStep';
import { ProviderIntentStep } from '../OnboardingSteps/IntentStep/ProviderIntentStep';
import { TransferIntentStep } from '../OnboardingSteps/IntentStep/TransferIntentStep';
import { MedicationsStep } from '../OnboardingSteps/MedicationStep/MedicationsStep';
import { PreviousPharmacyStep } from '../OnboardingSteps/PreviousPharmacyStep';
import { ProfileStep } from '../OnboardingSteps/ProfileStep';
import { WelcomeStep } from '../OnboardingSteps/WelcomeStep';
import { Content } from '../styles';

import { STEP_NAME } from './consts';

const STEP_LAYOUT = {
  [STEP_NAME.WELCOME]: WelcomeStep,
  [STEP_NAME.MEDICATIONS]: MedicationsStep,
  [STEP_NAME.PHARMACY]: PreviousPharmacyStep,
  [STEP_NAME.PROFILE]: ProfileStep,
  [STEP_NAME.DOCTOR]: DoctorStep,
  [STEP_NAME.CONTACT]: ContactStep,
  [STEP_NAME.JOIN_WAITLIST]: JoinWaitList,
  [STEP_NAME.WAITLIST_CONFIRMATION]: WaitlistConfirmation,
  [STEP_NAME.ELIGIBILITY_CONFIRMATION]: EligibilityConfirmation,
  [STEP_NAME.INELIGIBLE_STEP]: IneligibleStep,
  [STEP_NAME.WELCOME_BACK]: WelcomeBack,
  [STEP_NAME.TRANSFER_INTENT]: TransferIntentStep,
  [STEP_NAME.PROVIDER_INTENT]: ProviderIntentStep,
  [STEP_NAME.DOCTOR_INTENT]: DoctorIntentStep,
  [STEP_NAME.CAPTCHA]: CaptchaStep,
};

interface StepLayoutProps {
  currentStep: STEP_NAME;
  setIsOnSubpage: (arg0: boolean) => void;
  setShowFooter: (arg0: boolean) => void;
  setShowHorizontalProgressBar: (arg0: boolean) => void;
  shouldShowTransferFormFullProfileTransferInExperience: boolean;
}

export const StepLayout = ({
  currentStep,
  setIsOnSubpage,
  setShowFooter,
  setShowHorizontalProgressBar,
  shouldShowTransferFormFullProfileTransferInExperience,
}: StepLayoutProps) => {
  const dispatch = useDispatch();

  const handlePrevClick = () => dispatch(setPreviousOnboardingStep());
  const handleNextClick = () => dispatch(setNextOnboardingStep());

  const StepComponent = STEP_LAYOUT[currentStep];

  return (
    <Content isPharmacyStep={currentStep === STEP_NAME.PHARMACY}>
      <StepComponent
        handlePrevClick={handlePrevClick}
        handleNextClick={handleNextClick}
        setIsOnSubpage={setIsOnSubpage}
        setShowFooter={setShowFooter}
        setShowHorizontalProgressBar={setShowHorizontalProgressBar}
        shouldShowTransferFormFullProfileTransferInExperience={shouldShowTransferFormFullProfileTransferInExperience}
      />
    </Content>
  );
};
